import $ from 'jquery';
import '../vendors/jquery.magnific-popup';

$(document).on('click', (event) => {
	if ($(event.target).hasClass('js-open-content-popup')) {
		event.preventDefault();
		$(event.target).magnificPopup({
			type: 'inline',
		}).magnificPopup('open');
	}
});

$('.js-open-content-popup-brochure').magnificPopup({
	type: 'inline',
	callbacks: {
		open: function () {
			var selector = this.st.el.attr('href');
			var pardot_url = this.st.el.data('pardot-url');
			var modal_title = this.st.el.data('modal-title');
			var modal_description = this.st.el.data('modal-description');
			var modal_thumb = this.st.el.data('modal-thumb');
			//$('#download-paper-popup #modal-pardot-iframe').attr('src', pardot_url);
			//$('#download-paper-popup .c-popup__content h2 span').html(modal_title);
			//$('#download-paper-popup .c-popup__content p').html(modal_description);
			//$('#download-paper-popup .c-paper__pic img').attr('src', modal_thumb);
			$(selector + ' #modal-pardot-iframe').attr('src', pardot_url);
			$(selector + ' .c-popup__content h2 span').html(modal_title);
			$(selector + ' .c-popup__content p').html(modal_description);
			$(selector + ' .c-paper__pic img').attr('src', modal_thumb);
		},
		close: function () {
			//$('#download-paper-popup #modal-pardot-iframe').attr('src', '');
			//$('#download-paper-popup .c-popup__content h2 span').empty();
			//$('#download-paper-popup .c-popup__content p').empty();
			//$('#download-paper-popup .c-paper__pic img').attr('src', '');
			$(selector + ' #modal-pardot-iframe').attr('src', '');
			$(selector + ' .c-popup__content h2 span').empty();
			$(selector + ' .c-popup__content p').empty();
			$(selector + ' .c-paper__pic img').attr('src', '');
		},
	},
});

$('.js-open-content-popup-asset').magnificPopup({
	type: 'inline',
	callbacks: {
		open: function () {
			var pardot_url = this.st.el.data('pardot-url');
			var modal_title = this.st.el.data('modal-title');
			var modal_description = this.st.el.data('modal-description');
			var modal_thumb = this.st.el.data('modal-thumb');
			$('#download-paper-popup #modal-pardot-iframe').attr(
				'src',
				pardot_url
			);
			$('#download-paper-popup .c-popup__content h2').html(modal_title);
			$('#download-paper-popup .c-popup__photo-background p').html(
				modal_description
			);
			$('#download-paper-popup .c-popup__photo-background img').attr(
				'src',
				modal_thumb
			);
		},
		close: function () {
			$('#download-paper-popup #modal-pardot-iframe').attr('src', '');
			$('#download-paper-popup .c-popup__content h2').empty();
			$('#download-paper-popup .c-popup__photo-background p').empty();
			$('#download-paper-popup .c-popup__photo-background img').attr(
				'src',
				''
			);
		},
	},
});

$('.js-open-content-popup-asset-gf').magnificPopup({
	type: 'inline',
	callbacks: {
		beforeOpen: function () {
			$.ajax({
				url: cynosure_vars.ajax_url,
				data: {
					action: 'gf_button_get_form',
					query_str: this.st.el.data('query-str'),
					form_id: this.st.el.data('gf-id'),
					product_interest: this.st.el.data('product-interest'),
					product_requested: this.st.el.data('product-requested'),
					asset_selected: this.st.el.data('asset-selected'),
					embed_id: this.st.el.data('embed-id'),
				},
				type: 'post',
				dataType: 'json',
				beforeSend: function () {
					$('#gf-download-paper-popup #gform-container')
						.html('Loading form...')
						.fadeIn();
				},
				success: function (data, textStatus, XMLHttpRequest) {
					//console.log(data);
					//$('#gf-download-paper-popup #gform-container').html('test');
				},
				ajaxComplete: function () {},
				error: function (MLHttpRequest, textStatus, errorThrown) {},
				complete: function (data, textStatus) {
					$('#gf-download-paper-popup #gform-container').empty();
					$('#gf-download-paper-popup #gform-container')
						.html(data.responseText)
						.fadeIn();
				},
			});

			var modal_title = this.st.el.data('modal-title');
			var modal_description = this.st.el.data('modal-description');
			var modal_thumb = this.st.el.data('modal-thumb');
			$('#gf-download-paper-popup .c-popup__content h2').html(
				modal_title
			);
			$('#gf-download-paper-popup .c-popup__photo-background p').html(
				modal_description
			);
			$('#gf-download-paper-popup .c-popup__photo-background img').attr(
				'src',
				modal_thumb
			);
		},
		open: function () {},
		close: function () {
			$('#gf-download-paper-popup .c-popup__content h2').empty();
			$('#gf-download-paper-popup .c-popup__photo-background p').empty();
			$('#gf-download-paper-popup .c-popup__photo-background img').attr(
				'src',
				''
			);

			$('#gf-download-paper-popup #gform-container').empty();
		},
	},
});

$('.js-popup-map').magnificPopup({
	type: 'inline',
	callbacks: {
		open: function () {
			$('#gmap').detach().appendTo('#gmap-popup');
			$('#gmap').toggleClass('c-google-map--sm c-google-map--xl');
		},
		close: function () {
			$('#gmap').detach().appendTo('#gmap-inline');
			$('#gmap').toggleClass('c-google-map--sm c-google-map--xl');
		},
	},
});

$(function () {
	$('.js-open-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	});

	$('.js-open-wistia-video-popup').magnificPopup({
		type: 'iframe',
		iframe: {
			patterns: {
				wistia: {
					index: 'wistia.com',
					id: function (url) {
						var m = url.match(
							/^.+wistia.com\/.*?\/medias\/(.*)/
						);
						if (m[1]) {
							return m[1];
						}
						return null;
					},
					src: '//fast.wistia.com/embed/iframe/%id%?autoPlay=1', // https://wistia.com/doc/embed-options#options_list
				},
			},
		},
	});
});
